import { ReactNode, useEffect, useRef } from "react";
import { browserGuard, extendProps } from "../../../helpers/common";
import { Container, ContainerProps, Stack, StackProps } from "@mui/material";

export interface GetStartedFlowProps {
    footer?: ReactNode;
    children?: ReactNode;
    stackProps?: StackProps;
    outerChildren?: ReactNode;
}

function GetStartedFlow(props: GetStartedFlowProps) {
    const { children, footer, stackProps, outerChildren } = props;

    const containerRef = useRef(null);

    const containerProps: ContainerProps = {
        maxWidth: "sm",
        disableGutters: true,
        sx: {
            gap: 3,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            minHeight: "calc(100vh - 88px - 24px)",
        },
    };

    const newStackProps = extendProps(stackProps || {}, {
        sx: {
            gap: 3,
            height: "100%",
            ...props.stackProps?.sx,
        },
        children,
    });

    const bottomStackProps: StackProps = {
        sx: {
            gap: 3,
            textAlign: "center",
            alignItems: "center",
        },
        children: footer,
    };

    const methods = {
        updateContainerHeight() {
            if (containerRef?.current) {
                const element = containerRef.current as HTMLDivElement;

                element.style.setProperty("min-height", `calc(${window.innerHeight}px - 88px - 24px)`);
            }
        },
    };

    useEffect(() => {
        if (browserGuard()) {
            methods.updateContainerHeight();

            window.addEventListener("resize", methods.updateContainerHeight);
        }
    }, [browserGuard(), containerRef]);

    return (
        <>
            {outerChildren}
            <Container {...containerProps} ref={containerRef}>
                {children && <Stack {...newStackProps} />}
                {footer && <Stack {...bottomStackProps} />}
            </Container>
        </>
    );
}

export default GetStartedFlow;
